function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "CategoryMenuFavouriteSelected"
}, "CategoryMenu Favourite Selected");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.36391 0.736491C8.21449 0.42117 7.7855 0.42117 7.63609 0.736491L5.62428 4.9821C5.56512 5.10697 5.45142 5.19358 5.31988 5.214L0.847287 5.90823C0.515108 5.95979 0.382543 6.38759 0.622378 6.63403L3.85161 9.9522C3.94658 10.0498 3.99001 10.1899 3.96788 10.3274L3.21547 15.0021C3.15959 15.3493 3.50665 15.6137 3.80429 15.4507L7.81187 13.2558C7.92973 13.1912 8.07027 13.1912 8.18813 13.2558L12.1957 15.4507C12.4934 15.6137 12.8404 15.3493 12.7845 15.0021L12.0321 10.3274C12.01 10.1899 12.0534 10.0498 12.1484 9.9522L15.3776 6.63403C15.6175 6.38759 15.4849 5.95979 15.1527 5.90823L10.6801 5.214C10.5486 5.19358 10.4349 5.10697 10.3757 4.9821L8.36391 0.736491Z",
  fill: "#1C1C1C"
});

function SvgCategoryMenuFavouriteSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMenuFavouriteSelected);
export default __webpack_public_path__ + "static/media/CategoryMenuFavouriteSelected.83611f86805cd3baa086044d8974d77a.svg";
export { ForwardRef as ReactComponent };